import React, { ButtonHTMLAttributes, ReactNode, forwardRef } from 'react';

import { Container, IconWrapper } from './styles';

export type ButtonProps = {
  title: string;
  height?: number;
  fontSize?: number;
  secondary?: boolean;
  tertiary?: boolean;
  link?: boolean;
  iconLeft?: ReactNode;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const Button = forwardRef(({ title, iconLeft, ...props }: ButtonProps, ref: any) => (
  <Container ref={ref} {...props}>
    {!!iconLeft && <IconWrapper>{iconLeft}</IconWrapper>}
    {title}
  </Container>
));

export default Button;
